module.exports = __webpack_public_path__ + "assets/img/word-study-sound.947e6856.png";